// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-invoice-layout .simple-header {
  width: 100%;
  text-align: left;
}
.system-invoice-layout .simple-header .invoice-header-image {
  max-width: 100%;
  height: auto;
}
.system-invoice-layout .invoice-title {
  text-align: center;
}
.system-invoice-layout .invoice-title h1 {
  font-size: 20px;
  font-weight: bold;
  color: #004A9A;
  margin: 0;
  padding: 10px;
  border: 2px solid #004A9A;
  display: inline-block;
  letter-spacing: 2px;
}
.system-invoice-layout .single-block-info {
  line-height: 1.6;
  font-size: 14px;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
.system-invoice-layout .single-block-info p {
  margin: 4px 0;
}
.system-invoice-layout .single-block-info p strong {
  font-weight: 600;
}
.system-invoice-layout .system-invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0 20px 0;
  border: 1px solid #000;
}
.system-invoice-layout .system-invoice-table thead th {
  padding: 12px;
  text-align: left;
  font-weight: bold;
  border: 1px solid #000;
}
.system-invoice-layout .system-invoice-table thead th:nth-child(2) {
  text-align: center;
  width: 15%;
}
.system-invoice-layout .system-invoice-table thead th:nth-child(3) {
  text-align: right;
  width: 20%;
}
.system-invoice-layout .system-invoice-table tbody tr {
  border: 1px solid #000;
}
.system-invoice-layout .system-invoice-table tbody tr:not(.grand-total-row) td {
  padding: 12px;
  vertical-align: top;
  border: 1px solid #000;
}
.system-invoice-layout .system-invoice-table tbody tr:not(.grand-total-row) td:nth-child(2) {
  text-align: center;
}
.system-invoice-layout .system-invoice-table tbody tr:not(.grand-total-row) td:nth-child(3) {
  text-align: right;
}
.system-invoice-layout .system-invoice-table tbody tr.grand-total-row {
  font-weight: bold;
}
.system-invoice-layout .system-invoice-table tbody tr.grand-total-row td {
  padding: 12px;
  border: 1px solid #000;
  font-size: 15px;
}
.system-invoice-layout .simple-footer .bank-details-section {
  margin: 20px 0 20px 0;
  line-height: 1.8;
}
.system-invoice-layout .simple-footer .bank-details-section p {
  margin: 8px 0;
  font-size: 14px;
}
.system-invoice-layout .simple-footer .bank-details-section p strong {
  font-weight: 600;
}
.system-invoice-layout .simple-footer .footer-message {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}
.system-invoice-layout .simple-footer .footer-message .system-generated-note {
  font-size: 13px;
  color: #666;
  text-align: center;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/pages/Systeminvoicepdftemplate/Systeminvoicepdftemplate.scss"],"names":[],"mappings":"AAKE;EACE,WAAA;EAEA,gBAAA;AALJ;AAOI;EACE,eAAA;EACA,YAAA;AALN;AAUE;EACE,kBAAA;AARJ;AAWI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AATN;AAcE;EAEE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;AAbJ;AAeI;EACE,aAAA;AAbN;AAcM;EACE,gBAAA;AAZR;AAkBE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAhBJ;AAqBM;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAnBR;AAoBQ;EACE,kBAAA;EACA,UAAA;AAlBV;AAoBQ;EACE,iBAAA;EACA,UAAA;AAlBV;AAuBM;EACE,sBAAA;AArBR;AAuBU;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AArBZ;AAsBY;EACE,kBAAA;AApBd;AAsBY;EACE,iBAAA;AApBd;AAwBQ;EACE,iBAAA;AAtBV;AAuBU;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AArBZ;AA8BI;EACE,qBAAA;EACA,gBAAA;AA5BN;AA6BM;EACE,aAAA;EACA,eAAA;AA3BR;AA4BQ;EACE,gBAAA;AA1BV;AA+BI;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AA7BN;AA+BM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AA7BR","sourcesContent":["// Styles for Systeminvoicepdftemplate\n\n\n.system-invoice-layout {\n  // 1. HEADER: Simple Image Style (with 100% width)\n  .simple-header {\n    width: 100%;\n    //margin-bottom: 10px; // Reduced spacing\n    text-align: left;\n\n    .invoice-header-image {\n      max-width: 100%; // Fixes small image\n      height: auto;\n    }\n  }\n\n  // 2. TITLE: Updated with Blue Box\n  .invoice-title {\n    text-align: center;\n    //margin-bottom: 30px;\n    \n    h1 {\n      font-size: 20px;\n      font-weight: bold;\n      color: #004A9A;\n      margin: 0;\n      padding: 10px;\n      border: 2px solid #004A9A;\n      display: inline-block;\n      letter-spacing: 2px;\n    }\n  }\n\n  // 3. INFO BOX: Reduced spacing\n  .single-block-info {\n    //margin: 15px 0; // Reduced spacing\n    line-height: 1.6; // Tighter line spacing\n    font-size: 14px;\n    border-bottom: 1px solid #000;\n    padding-bottom: 10px; // Reduced padding\n\n    p {\n      margin: 4px 0; // Reduced paragraph spacing\n      strong {\n        font-weight: 600;\n      }\n    }\n  }\n\n  // 4. TABLE STYLES: Reduced top margin\n  .system-invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 15px 0 20px 0; // Reduced top spacing\n    border: 1px solid #000;\n\n    thead {\n      //background-color: #004a9a;\n      //color: white;\n      th {\n        padding: 12px;\n        text-align: left;\n        font-weight: bold;\n        border: 1px solid #000;\n        &:nth-child(2) {\n          text-align: center;\n          width: 15%;\n        }\n        &:nth-child(3) {\n          text-align: right;\n          width: 20%;\n        }\n      }\n    }\n    tbody {\n      tr {\n        border: 1px solid #000;\n        &:not(.grand-total-row) {\n          td {\n            padding: 12px;\n            vertical-align: top;\n            border: 1px solid #000;\n            &:nth-child(2) {\n              text-align: center;\n            }\n            &:nth-child(3) {\n              text-align: right;\n            }\n          }\n        }\n        &.grand-total-row {\n          font-weight: bold;\n          td {\n            padding: 12px;\n            border: 1px solid #000;\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  // 5. FOOTER: Reduced spacing\n  .simple-footer {\n    .bank-details-section {\n      margin: 20px 0 20px 0; // Reduced top spacing\n      line-height: 1.8;\n      p {\n        margin: 8px 0;\n        font-size: 14px;\n        strong {\n          font-weight: 600;\n        }\n      }\n    }\n\n    .footer-message {\n      margin-top: 30px; // Reduced top spacing\n      padding-top: 20px;\n      border-top: 1px solid #ddd;\n\n      .system-generated-note {\n        font-size: 13px;\n        color: #666;\n        text-align: center;\n        font-style: italic;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
